"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDashboard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactGridLayout = require("react-grid-layout");

var _sbDashboardItem = _interopRequireDefault(require("./sb-dashboard-item"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ResponsiveReactGridLayout = _reactGridLayout.Responsive;

var SbDashboard = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbDashboard, _PureComponent);

  var _super = _createSuper(SbDashboard);

  function SbDashboard(props) {
    var _this;

    _classCallCheck(this, SbDashboard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWindowResizeEnd", function () {
      /**
       * This method is attached on a `resize` event listener, which have to call it on every window resizing.
       * The `resizeDelayTime` prop forces to delay the actual resizing, improving the performance.
       * */
      var resizeDelayTime = _this.props.resizeDelayTime;
      clearTimeout(_this.resizeTimeout);
      _this.resizeTimeout = setTimeout(_this.onWindowResize, resizeDelayTime);
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResize", function () {
      if (_this.measure) {
        _this.setState({
          width: _this.measure.clientWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getWrapperClassNames", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          wrapperClassName = _this$props.wrapperClassName;
      return (0, _classnames.default)('sb-dashboard-wrapper', className, wrapperClassName);
    });

    _defineProperty(_assertThisInitialized(_this), "getLayoutClassNames", function (layoutClassName, disabled) {
      return (0, _classnames.default)('sb-dashboard', layoutClassName, !disabled && 'editable-grid');
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStateChange", function (dragging) {
      _this.setState({
        dragging: dragging
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizeStateChange", function (resizing) {
      _this.setState({
        resizing: resizing
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItems", function (items) {
      var _this$props2 = _this.props,
          componentList = _this$props2.componentList,
          onRemoveItem = _this$props2.onRemoveItem,
          showRemoveButton = _this$props2.showRemoveButton;
      var _this$state = _this.state,
          dragging = _this$state.dragging,
          resizing = _this$state.resizing;
      return items.map(function (item) {
        var dataGrid;
        var draggableClassName;
        /**
         * `initData` is an object with all params for initial generating of an element with specific size to a specific position.
         * It is generated by `createNewItem` method in utils.js
         */

        if (item.initData) {
          dataGrid = item.initData;
          draggableClassName = dataGrid.isDraggable === false && 'non-draggable';
        }

        var _componentList = componentList(item.id, {
          onRemove: function onRemove() {
            return onRemoveItem(item.key);
          }
        }),
            component = _componentList.component;

        return /*#__PURE__*/_react.default.createElement("div", {
          key: "grid-item-".concat(item.key),
          id: item.id,
          "data-grid": dataGrid,
          className: (0, _classnames.default)(draggableClassName, 'sb-box')
        }, component && /*#__PURE__*/_react.default.createElement(_sbDashboardItem.default, {
          dragging: dragging,
          resizing: resizing
        }, component), showRemoveButton && /*#__PURE__*/_react.default.createElement("span", {
          className: "remove-grid-item",
          onClick: function onClick() {
            return onRemoveItem(item.key);
          }
        }, "\xD7"));
      });
    });

    _this.state = {
      width: 1280,
      dragging: false,
      resizing: false
    };
    _this.resizeTimeout = null;
    _this.measure = null;
    return _this;
  }

  _createClass(SbDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          onBreakpointChange = _this$props3.onBreakpointChange,
          cols = _this$props3.cols;
      /**
       * Calling the onBreakpointChange method to get the initial value breakpoint and column size on first load.
       * If the initial breakpoint is smaller as `lg`, then the onBreakpointChange will be triggered second time to rewrite this value.
       * */

      onBreakpointChange(_constants.breakpointSize.LG, cols.lg);
      this.onWindowResize();
      window.addEventListener('resize', this.onWindowResizeEnd);
      window.addEventListener('load', this.onWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onWindowResizeEnd);
      window.removeEventListener('load', this.onWindowResize);
      clearTimeout(this.resizeTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          cols = _this$props4.cols,
          compactType = _this$props4.compactType,
          breakpoints = _this$props4.breakpoints,
          draggableCancel = _this$props4.draggableCancel,
          draggableHandle = _this$props4.draggableHandle,
          id = _this$props4.id,
          items = _this$props4.items,
          layouts = _this$props4.layouts,
          layoutClassName = _this$props4.layoutClassName,
          layoutId = _this$props4.layoutId,
          layoutStyle = _this$props4.layoutStyle,
          margin = _this$props4.margin,
          containerPadding = _this$props4.containerPadding,
          mode = _this$props4.mode,
          onLayoutChange = _this$props4.onLayoutChange,
          onBreakpointChange = _this$props4.onBreakpointChange,
          preventCollision = _this$props4.preventCollision,
          rowHeight = _this$props4.rowHeight,
          useCSSTransforms = _this$props4.useCSSTransforms,
          style = _this$props4.style,
          wrapperStyle = _this$props4.wrapperStyle,
          rest = _objectWithoutProperties(_this$props4, ["cols", "compactType", "breakpoints", "draggableCancel", "draggableHandle", "id", "items", "layouts", "layoutClassName", "layoutId", "layoutStyle", "margin", "containerPadding", "mode", "onLayoutChange", "onBreakpointChange", "preventCollision", "rowHeight", "useCSSTransforms", "style", "wrapperStyle"]);

      var width = this.state.width;
      var disabled = mode !== _constants.dashboardMode.EDIT;
      var draggableState = disabled ? '.doesnt-exist' : draggableHandle;
      var wrapperStyles = Object.assign({}, wrapperStyle, style);
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(_ref) {
          _this2.measure = _ref;
        },
        id: id,
        className: this.getWrapperClassNames(),
        style: wrapperStyles
      }, /*#__PURE__*/_react.default.createElement(ResponsiveReactGridLayout, _extends({}, rest, {
        breakpoints: breakpoints,
        className: this.getLayoutClassNames(layoutClassName, disabled),
        cols: cols,
        compactType: compactType,
        draggableCancel: draggableCancel,
        draggableHandle: draggableState,
        id: layoutId,
        layouts: layouts,
        style: layoutStyle,
        margin: margin,
        containerPadding: containerPadding,
        onLayoutChange: onLayoutChange,
        onBreakpointChange: onBreakpointChange,
        rowHeight: rowHeight,
        width: width,
        preventCollision: preventCollision,
        useCSSTransforms: useCSSTransforms,
        onDragStart: function onDragStart() {
          return _this2.handleDragStateChange(true);
        },
        onDragStop: function onDragStop() {
          return _this2.handleDragStateChange(false);
        },
        onResizeStart: function onResizeStart() {
          return _this2.handleResizeStateChange(true);
        },
        onResizeStop: function onResizeStop() {
          return _this2.handleResizeStateChange(false);
        }
      }), this.renderItems(items)));
    }
  }]);

  return SbDashboard;
}(_react.PureComponent);

exports.SbDashboard = SbDashboard;

_defineProperty(SbDashboard, "propTypes", {
  breakpoints: _propTypes.default.shape({
    lg: _propTypes.default.number,
    md: _propTypes.default.number,
    sm: _propTypes.default.number,
    xs: _propTypes.default.number,
    xxs: _propTypes.default.number
  }),
  className: _propTypes.default.string,
  cols: _propTypes.default.shape({
    lg: _propTypes.default.number,
    md: _propTypes.default.number,
    sm: _propTypes.default.number,
    xs: _propTypes.default.number,
    xxs: _propTypes.default.number
  }),
  compactType: _propTypes.default.oneOf([_constants.compactTypes.HORIZONTAL, _constants.compactTypes.VERTICAL, _constants.compactTypes.OFF]),
  componentList: _propTypes.default.func,
  containerPadding: _propTypes.default.arrayOf(_propTypes.default.number),
  draggableCancel: _propTypes.default.string,
  draggableHandle: _propTypes.default.string,
  id: _propTypes.default.string,
  items: _propTypes.default.array,
  // eslint-disable-line
  layouts: _propTypes.default.object,
  // eslint-disable-line
  layoutClassName: _propTypes.default.string,
  layoutId: _propTypes.default.string,
  layoutStyle: _propTypes.default.object,
  // eslint-disable-line
  margin: _propTypes.default.arrayOf(_propTypes.default.number),
  mode: _propTypes.default.oneOf([_constants.dashboardMode.EDIT, _constants.dashboardMode.VIEW]),
  onLayoutChange: _propTypes.default.func,
  onBreakpointChange: _propTypes.default.func,
  onRemoveItem: _propTypes.default.func,
  preventCollision: _propTypes.default.bool,
  resizeDelayTime: _propTypes.default.number,
  rowHeight: _propTypes.default.number,
  showRemoveButton: _propTypes.default.bool,
  style: _propTypes.default.object,
  // eslint-disable-line
  useCSSTransforms: _propTypes.default.bool,
  wrapperClassName: _propTypes.default.string,
  wrapperStyle: _propTypes.default.object // eslint-disable-line

});

_defineProperty(SbDashboard, "defaultProps", {
  breakpoints: {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0
  },
  className: null,
  cols: {
    lg: 30,
    md: 26,
    sm: 22,
    xs: 18,
    xxs: 14
  },
  compactType: _constants.compactTypes.HORIZONTAL,
  componentList: function componentList() {},
  containerPadding: [0, 0],
  draggableCancel: null,
  draggableHandle: null,
  id: null,
  items: [],
  layouts: {},
  layoutClassName: '',
  layoutId: null,
  layoutStyle: {},
  margin: [10, 10],
  mode: _constants.dashboardMode.EDIT,
  onBreakpointChange: function onBreakpointChange() {},
  onLayoutChange: function onLayoutChange() {},
  onRemoveItem: function onRemoveItem() {},
  preventCollision: false,
  resizeDelayTime: _constants.delayTime.ONRESIZE,
  rowHeight: 40,
  showRemoveButton: true,
  style: null,
  useCSSTransforms: true,
  wrapperClassName: '',
  wrapperStyle: {}
});
//# sourceMappingURL=sb-dashboard.js.map